const comments = [
    {
        id: 1234,
        name: "Carl Moose",
        content: "Lorem ipsum dolor sit ametco nsec te tuer adipiscing elitae ipsum dolor sit ametco nse adipiscing elit",
        image: "/users/user-img-1.png",
        date: "April 10, 2022 at 2:34 pm",
        replier: [
            {
                id: 1535,
                name: "John Rios",
                content: "Tenetur natus porro magnam voluptates animi",
                image: "/users/user-img-5.png",
                date: "April 10, 2022 at 2:50 pm",
                reply: "Carl Moose",
                replyId: 1234,
            },
            {
                id: 3634,
                name: "Sam Smith",
                content: "Optio unde obcaecati officia commodi pariatur, tenetur natus porro magnam voluptates animi",
                image: "/users/user-img-6.png",
                date: "April 10, 2022 at 3:15 pm",
                reply: "Carl Moose",
                replyId: 1234
            },
        ],
    },
    {
        id: 6344,
        name: "James Fisher",
        content: "Voluptas repellat possimus amet laudantium adipisci provident maxime consequatur tempore ad deserunt. Liber consectetuer in mei, sea in imperdiet.",
        image: "/users/user-img-2.png",
        date: "April 10, 2022 at 2:38 pm",
        replier: [],
    },
]

export default comments